import { findChildren } from "@tiptap/core";
const findNodeById = (tr, id) => {
  return findChildren(tr.doc, (node) => node.attrs.id === id);
};
export {
  findNodeById
};
//# sourceMappingURL=findNodeById.js.map
